const data: any = {
  func: {
    apiHost: "//joshome.jd.com",
    moreProposalPlaceholder: "请详细描述您在使用文档中遇到的问题。例如：文档中的使用与实际线上场景不符，需要更新文档。",
    proposalList: [
      { value: "文档内容不全面或信息缺失" },
      { value: "文档内容有错误" },
      { value: "文档不符合业务场景" },
      { value: "文档未更新" },
      { value: "无" },
    ],
    loginHost: "https://passport.jd.com/new/login.aspx",
  },
  style: {},
  data: {},
  _clstag_: "jdzeus_commondoc_zeus_doc_common_doclist",
};
export default data;
